module.exports = __webpack_public_path__ + "static/media/5000d.fefef327.jpg";